var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import waitForTarget from 'wait-for-target';
import { createDebug } from '@rambler-id/debug';
var debug = createDebug('common:metrics:top100');
export var activateTop100 = function (option) {
    return new Promise(function (resolve) {
        if (process.env.NODE_ENV === 'development') {
            resolve();
            return;
        }
        /* eslint-disable */
        // prettier-ignore
        (function (w, d, c) {
            // @ts-ignore
            (w[c] = w[c] || []).push(function () {
                try {
                    // @ts-ignore
                    w.top100Counter = new top100(__assign({ project: option.key, attributes_dataset: option.dataset }, option.params));
                }
                catch (e) { }
            });
            // @ts-ignore
            var n = d.getElementsByTagName("script")[0], s = d.createElement("script"), f = function () { n.parentNode.insertBefore(s, n); };
            s.type = "text/javascript";
            s.async = true;
            s.src =
                (d.location.protocol == "https:" ? "https:" : "http:") +
                    "//st.top100.ru/top100/top100.js";
            s.onload = function () { return resolve(); };
            s.onerror = function () { return resolve(); };
            // @ts-ignore
            if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
            }
            else {
                f();
            }
        })(window, document, "_top100q");
        /* eslint-enable */
    });
};
export var sendCustomVars = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var top100Counter, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (process.env.NODE_ENV === 'development') {
                    debug('sendCustomVars %o', params);
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, waitForTarget(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    function () { return window.top100Counter; }, 1000)];
            case 2:
                top100Counter = _b.sent();
                top100Counter.sendCustomVars(params);
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var trackPageview = function () { return __awaiter(void 0, void 0, void 0, function () {
    var top100Counter, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (process.env.NODE_ENV === 'development') {
                    debug('trackPageview');
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, waitForTarget(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    function () { return window.top100Counter; }, 1000)];
            case 2:
                top100Counter = _b.sent();
                top100Counter.trackPageview();
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var trackEvent = function (eventName, eventData) { return __awaiter(void 0, void 0, void 0, function () {
    var top100Counter, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (process.env.NODE_ENV === 'development') {
                    debug("trackEvent, ".concat(eventName, ", %o"), eventData);
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, waitForTarget(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    function () { return window.top100Counter; }, 1000)];
            case 2:
                top100Counter = _b.sent();
                top100Counter.trackEvent(eventName, eventData);
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
